import React from 'react'
import {formatInZone, zoneNotice} from 'helpers/datetime'
import {Col, Row, List, Tag, Typography} from 'antd'
import {Spin} from 'antd'
import {useMutation, useQuery} from 'react-query'

import Item from './Item'
import * as counterQueries from '../../../queries/counter.queries'
import * as Styled from './counterview.styled'
import Link from 'components/SafeLink'

const {Title} = Typography

function CounterView({params}) {
    const counterQuery = useQuery(
        ['id', params.id],
        counterQueries.getCounterById,
    )

    const counter = counterQuery.data?.data.data

    /* G40-456: render this record's times on the clock they belong to — the
       order's, supplied by the API, or the operator's when the record has no
       order behind it. `zoneLine` names which, and says when it was inferred. */
    const fmt = (value, options = {}) =>
        formatInZone(value, counter?.order_timezone, options)
    const zoneLine = zoneNotice(
        counter?.order_timezone,
        counter?.order_timezone_source,
    )
    if (counterQuery.isLoading) {
        return (
            <Styled.Root>
                <Spin />
            </Styled.Root>
        )
    }

    return (
        <>
            {/* G40-456 zone caption — say whose clock these times are on */}
            <div
                style={{
                    fontSize: '85%',
                    opacity: 0.75,
                    margin: '0 0 10px 8px',
                }}>
                {zoneLine}
            </div>

            <div className="order">
                <Col sm={4} md={6} xl={8}>
                    <List
                        size="small"
                        bordered
                        style={{background: 'rgba(0,0,0,0.03)'}}
                        header={<Title level={5}>Basic Info</Title>}>
                        <Item body={counter.id || 'N/A'} title="ID#" />
                        <Item body={counter.title || 'N/A'} title="Title" />

                        <Item
                            body={
                                <Link to={`/booking/${counter.order_id}`}>
                                    {counter.order_id}
                                </Link>
                            }
                            title="Order ID "
                        />

                        <Item
                            body={
                                <Link to={`/user/${counter.gopher_id}`}>
                                    {counter.gopher}
                                </Link>
                            }
                            title="Gopher"
                        />
                        <Item
                            body={
                                <Link to={`/user/${counter.requestor_id}`}>
                                    {counter.requestor}
                                </Link>
                            }
                            title="Requestor"
                        />
                        <Item
                            body={
                                counter.status !== 'Declined' ? (
                                    <Tag color="green">{counter.status}</Tag>
                                ) : (
                                    <Tag color="red">{counter.status}</Tag>
                                )
                            }
                            title="Status"
                        />
                    </List>
                </Col>
                <Col sm={16} md={12} xl={8}>
                    <List
                        size="small"
                        bordered
                        style={{background: 'rgba(0,0,0,0.03)'}}>
                        <Item
                            body={`$ ${parseFloat(counter.order_offer / 100).toFixed(2)}`}
                            title="Order Offer"
                        />
                        <Item
                            body={`$ ${parseFloat(counter.order_cog / 100).toFixed(2)}`}
                            title="Order COG"
                        />
                        <Item
                            body={`$ ${parseFloat(counter.counter_offer / 100).toFixed(2)}`}
                            title="Counter Offer"
                        />
                        <Item
                            body={`$ ${parseFloat(counter.counter_cog / 100).toFixed(2)}`}
                            title="Counter COG"
                        />
                        <Item body={counter.comment || 'N/A'} title="Comment" />

                        <Item
                            body={fmt(counter.created_at, {dateOnly: true})}
                            title="Created On"
                        />
                    </List>
                </Col>

                <Col sm={4} md={6} xl={8}>
                    <List
                        size="small"
                        bordered
                        style={{background: 'rgba(0,0,0,0.03)'}}>
                        <Item
                            body={`$ ${parseFloat(counter.order_hourly_wage / 100).toFixed(2)}`}
                            title="Order Hourly wage"
                        />
                        <Item
                            body={`$ ${parseFloat(counter.counter_hourly_wage / 100).toFixed(2)}`}
                            title="Counter Hourly wage"
                        />
                        <Item
                            body={
                                counter.order_gopher_needed
                                    ? counter.order_gopher_needed
                                    : 0
                            }
                            title="Order Gopher Needed"
                        />
                        <Item
                            body={
                                counter.counter_gopher_needed
                                    ? counter.counter_gopher_needed
                                    : 0
                            }
                            title="Counter Gopher Needed"
                        />
                        <Item
                            body={
                                counter.order_noof_hours
                                    ? counter.order_noof_hours
                                    : 0
                            }
                            title="Order No Of Hours"
                        />
                        <Item
                            body={
                                counter.counter_noof_hours
                                    ? counter.counter_noof_hours
                                    : 0
                            }
                            title="Counter No Of Hours"
                        />
                    </List>
                </Col>
            </div>
        </>
    )
}

export default CounterView
